import { axios } from '@/utils';

export const getMoneyByLines = async (params: Record<string, unknown>) =>
  (
    await axios.get(`/monitor/getMoneyByLines`, {
      params,
    })
  ).data.data;
export const getMoneyByMethod = async (params: Record<string, unknown>) =>
  (
    await axios.get(`/monitor/getMoneyByMethod`, {
      params,
    })
  ).data.data;
export const getProductsByRangeDate = async (params: Record<string, unknown>) =>
  (
    await axios.get(`/monitor/`, {
      params,
    })
  ).data.data;
export const getMonitorByCategories = (params: Record<string, unknown>) => async () =>
  (
    await axios.get(`/monitor/monitorCategories`, {
      params,
    })
  ).data.data;
export const getAmountProductByLines = async (params: Record<string, unknown>) =>
  (
    await axios.get(`/monitor/getAmountProductsByLines`, {
      params,
    })
  ).data.data;

export const getMethodIndicatorsAndDiscountTotalbyOrders = async (
  params: Record<string, unknown>
) =>
  (
    await axios.get(`/monitor/getMethodIndicatorsAndDiscountTotalbyOrders`, {
      params,
    })
  ).data.data;
